<div class="page admin js-page">
  <app-service-side-nav class="hidden-print sidenav" [selectedTab]="selected" (onComponentSelected)="select($event)"></app-service-side-nav>
  <div class="adminpanel">
    <div class="adminobjects" id="service_list" *ngIf="isSelected('service_list')" app-service-list></div>
    <div class="adminobjects" id="completed_works_list" *ngIf="isSelected('completed_works_list')" completed-works-list></div>
    <div class="adminobjects" id="service_report" *ngIf="isSelected('service_report')" app-service-report></div>
    <div class="adminobjects" id="service_checkup" *ngIf="isSelected('service_checkup')" app-service-checkup></div>
  </div>
</div>
<template #mgmtDialog>
</template>
